import { InjectionKey } from "vue";

export const helpMenuFunctionKey = Symbol() as InjectionKey<{
  [key: string]: () => void;
}>;
